import { fetcher } from '@commenda/utils';

import { TUpdateBillingCountryPackParams } from './types';

export const updateBillingCountryPack = async (packId: string, params: TUpdateBillingCountryPackParams) => {
  const response = await fetcher(`commenda-billing/catalog/packs/${packId}`, {
    method: 'PATCH',
    body: params,
  });

  return response;
};
